<!-- <template>
  <router-view />
</template>

<script setup>
import { useVisitTracker } from "@/helpers/useVisitTracker";

useVisitTracker();
</script> -->

<template>
  <router-view />
</template>

<script setup>
import { onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useVisitTracker } from "@/helpers/useVisitTracker";
import { scheduleSessionTimers } from "@/helpers/sessionTimers";

const store = useStore();
const router = useRouter();

useVisitTracker();

onMounted(() => {
  const expiresAt = store.state.auth.expiresAt || null;
  scheduleSessionTimers(expiresAt, store, router);
});

watch(
  () => store.state.auth.expiresAt,
  (newExpiresAt) =>
    newExpiresAt && scheduleSessionTimers(newExpiresAt, store, router),
);
</script>
